export default __webpack_public_path__ + "static/Objective-Medium-152190ed89a051cd9584b8ed7eeeb0d4.otf";